/* eslint-disable react/no-unescaped-entities */
import Image from "next/image";
import React, { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Row,
} from "reactstrap";
import Link from "next/link";

import classes from "@/styles/partners/partner-service-details.module.css";
import { routes } from "@/utils/routes";
import { partner as p } from "@/utils/content";
import {
  smallLogo,
  upsCarrierList,
  upsConnect,
  upsConnectCarrier,
  upsConnectCarrierButton,
} from "@/utils/images";
import { MdOutlineAdd } from "react-icons/md";
import { useIsMobile } from "@/hooks/useIsMobile";

const PartnerServiceDetails = ({
  servicesDetails,
  partnerName,
  hasConnectionSteps,
}: any) => {
  const content = p.en;
  const isMobile = useIsMobile();
  const [open, setOpen] = useState<string>("1");

  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <>
      <section>
        <div
          className={classes.banner}
          style={{ backgroundColor: servicesDetails?.bannerColor }}
        >
          <div className={`${classes.topSection}`}>
            <h1 className={classes.topTitle}>{servicesDetails?.title1}</h1>
            <div className="d-flex align-items-center justify-content-center my-5">
              <div
                className={`${
                  ["tforce"].includes(partnerName) ? classes.circles2 : ""
                }`}
              >
                <Image
                  className={`${isMobile ? "me-4" : "me-5"} img-fluid`}
                  src={servicesDetails?.logoPath}
                  alt={`${partnerName} Logo`}
                  height={80}
                  width={isMobile ? 80 : 100}
                />
              </div>
              <MdOutlineAdd size={50} />
              <div className={classes.circles + " ms-5"}>
                <Image
                  className="img-fluid"
                  src={smallLogo}
                  alt={partnerName}
                  height={70}
                  width={120}
                />
              </div>
            </div>
            <p className={classes.topDescription}>
              {servicesDetails?.topDescription}
            </p>
          </div>
        </div>
      </section>
      <div className="container">
        <section className="my-5">
          <p className="text-center">{servicesDetails?.para1}</p>
        </section>
        <section className="my-5">
          <Row>
            <Col xs={12} lg={6}>
              <ul>
                {servicesDetails?.features?.map((f: string, i: number) => {
                  return (
                    <li className="" key={i}>
                      {f}
                    </li>
                  );
                })}
              </ul>
            </Col>
            <Col className="text-center" xs={12} lg={6}>
              <Image
                src={servicesDetails?.image1}
                alt={servicesDetails?.title1}
                height={275}
                width={270}
              />
            </Col>
          </Row>
        </section>
        {/* This section is only used on /partners/ups/ready-program page */}
        {hasConnectionSteps && (
          <section>
            <div>
              <h2>How to connect your Carrier Account</h2>
            </div>
            <div>
              <div className="text">
                <h5>Navigate to page</h5>
                <p>
                  Visit the Carrier Integrations page in the account setting
                  sections of the app.
                </p>
              </div>
              <div className="img">
                <Image
                  src={upsConnectCarrier}
                  alt="Connect Carrier"
                  width={500}
                  height={300}
                  className="img-fluid"
                />
              </div>
            </div>
            <div>
              <div className="text">
                <h5>Click Connect Button</h5>
                <p>
                  Click the 'Connect Carrier Account' button near the top right
                  hand corner of the screen.
                </p>
              </div>
              <div className="img">
                <Image
                  src={upsConnectCarrierButton}
                  alt="click connect carrier button"
                  className="img-fluid"
                  width={500}
                  height={300}
                />
              </div>
            </div>
            <div>
              <div className="text">
                <h5>Select UPS</h5>
                <p>
                  In the dialog that opens, select the UPS logo and a form
                  should open.
                </p>
              </div>
              <div className="img">
                <Image
                  src={upsCarrierList}
                  alt="select ups logo"
                  width={500}
                  height={300}
                  className="img-fluid"
                />
              </div>
            </div>
            <div>
              <div className="text">
                <h5>Connect!</h5>
                <p>
                  In the form, enter the correct information and proceed by
                  clicking the 'Connect Account' button at the bottom of the
                  form.
                </p>
              </div>
              <div className="img">
                <Image
                  src={upsConnect}
                  alt="connect account"
                  className="img-fluid"
                  width={500}
                  height={400}
                />
              </div>
            </div>
          </section>
        )}
        <section className="my-5 w-50 m-auto pt-5">
          <h3 className="text-center">{servicesDetails?.title2}</h3>
          <p className="text-center">{servicesDetails?.para2}</p>
          <Link
            className="btn btn btn-outline-secondary text-uppercase d-block mx-auto w-75"
            href={routes.register}
          >
            {servicesDetails?.accessBtnText}
          </Link>
        </section>
        <section className="my-5">
          <Row>
            <Col xs={12} lg={3}>
              <h2 className="mt-4">{content.faq}</h2>
              {/*@ts-ignore*/}
              <p>{content.faqPara(partnerName)}</p>
              <p>{servicesDetails?.faqPara2}</p>
            </Col>
            <Col xs={12} lg={9}>
              {/*@ts-ignore*/}
              <Accordion className="my-4" open={open} toggle={toggle}>
                {servicesDetails?.faqs?.map(
                  (
                    f: {
                      title: string;
                      desc: string;
                    },
                    i: string
                  ) => {
                    return (
                      <AccordionItem key={i}>
                        <AccordionHeader targetId={(i + 1).toString()}>
                          {f.title}
                        </AccordionHeader>
                        <AccordionBody accordionId={(i + 1).toString()}>
                          <p>{f.desc}</p>
                        </AccordionBody>
                      </AccordionItem>
                    );
                  }
                )}
              </Accordion>
            </Col>
          </Row>
        </section>
      </div>
    </>
  );
};

export default PartnerServiceDetails;
